export class DocumentExpirationDatesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentExpirationDates({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/document-expiration-dates`);
  }

  async createDocumentExpirationDate({ applicationId, ...body }) {
    return this.#http.post(`/application/${applicationId}/document-expiration-dates`, body);
  }

  async getDocumentExpirationDateById({ applicationId, id }) {
    return this.#http.get(`/application/${applicationId}/document-expiration-dates/${id}`);
  }

  async editDocumentExpirationDate({ applicationId, id, ...body }) {
    return this.#http.put(`/application/${applicationId}/document-expiration-dates/${id}`, body);
  }

  async deleteDocumentExpirationDate({ applicationId, id, ...params }) {
    return this.#http.delete(`/application/${applicationId}/document-expiration-dates/${id}`, {
      params,
    });
  }
}
